import React from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import classnames from 'classnames';

import dialogsMapper from './DialogsMapper';

import './DialogsList.custom.scss';
import './DialogsList.theme.scss';

export default function DialogList(props) {
  const { dialogs, dialogsIds, closeDialog, removeDialog, renderBackdrop, dialogsWrapperOnClick } = props;

  const dialogsComponents = dialogsIds.map((id) => {
    const dialogById = dialogs.get(id);

    const { dialogType } = dialogById;
    const Component = dialogsMapper(dialogType);

    if (!Component) {
      return null;
    }

    return (
      <Component
        key={id}
        id={id}
        className={renderBackdrop ? 'react-dialogs-scrollable' : null}
        selfClose={() => closeDialog({ id })}
        selfRemove={() => removeDialog({ id })}
        {...dialogById}
      />
    );
  });
  const closingBackdrop = dialogs.every((item) => {
    return item.closed;
  });

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <section
      className={classnames('react-dialogs-backdrop', {
        'react-dialogs-with-backdrop': renderBackdrop,
        'react-dialogs-no-backdrop': !renderBackdrop,
        'react-dialogs-with-backdrop-closing': closingBackdrop,
      })}
      onClick={dialogsWrapperOnClick}>
      {dialogsComponents}
    </section>
  );
}

DialogList.propTypes = {
  dialogs: PropTypes.instanceOf(Map),
  dialogsIds: PropTypes.instanceOf(List),
  closeDialog: PropTypes.func,
  renderBackdrop: PropTypes.bool,
  dialogsWrapperOnClick: PropTypes.func,
  removeDialog: PropTypes.func,
};
